import apiService from '../apiService';

const UserApi = {
  getUser: (id) => apiService.get(`/users/${id}`),
  updateUser: (id, data) => apiService.put(`/users/${id}`, data),
  updateUserStatus: (id, data) => apiService.put(`/users/${id}/status`, data),
  deleteUser: (id) => apiService.delete(`/users/${id}`),
  listUsers: (params) => apiService.get('/users', params),
};

export default UserApi;
